import type { SituacaoCotacaoDialogProps } from "./types-situacao-cotacao-dialog";
import { useSituacaoCotacaoDialog } from "./use-situacao-cotacao-dialog";
import { SituacaoCotacaoDialogView } from "./view-situacao-cotacao-dialog";

export function SituacaoCotacaoDialog(props: SituacaoCotacaoDialogProps) {
  const vm = useSituacaoCotacaoDialog(props);

  return <SituacaoCotacaoDialogView {...vm} />;
}

export type * from "./types-situacao-cotacao-dialog";
